import styles from './flow-content.module.css';

export function FlowContent({ children }: { children: React.ReactNode }): React.JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
